import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
// import { ReactComponent as Icons } from "../../../img/icons.svg";
import Icons from "../../../img/icons.svg";
import "./MenuItem.scss";

export default (props) => {
  const w = props.width? props.width : 36;
  const h = props.height? props.height : 36;
  return (
    <Nav.Item as="li">
      <NavLink {...props} className={`Menu__item`}>
        {props.icon && (
          <svg className={`Menu__icon`} width={w} height={h}>
            <use xlinkHref={`${Icons}#icon-${props.icon}`} />
          </svg>
        )}
        {props.title}
      </NavLink>
    </Nav.Item>
  );
};
